import React from "react";

import { faInfoCircle } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Icon, Text } from "@performyard/py-components";

/**
 * A step-level error in the same visual language as `InputWrapper`'s field errors —
 * the wizard's designs use it for validation that belongs to a whole step (no subjects
 * selected, no to-dos) rather than to a single input, so an alert banner would be too
 * heavy. Mirrors py-components' `InputError`, which only renders inside an InputWrapper.
 */
export const InlineError = ({ message, "data-testid": dataTestId }: { message: string; "data-testid"?: string }) => (
	<div className="flex items-start gap-1" role="alert" aria-live="assertive" data-testid={dataTestId}>
		<Icon icon={faInfoCircle} size={16} color="red-5" aria-hidden="true" />
		<Text size="paragraph-3" color="red-5" weight="regular">
			{message}
		</Text>
	</div>
);
